/**
 * Format points with comma separator and no decimals
 * @param {number} points - The points value to format
 * @returns {string} - Formatted points string
 */
export const formatPoints = (points) => {
  // Convert to integer to remove decimals and format with commas
  return Math.floor(points || 0).toLocaleString();
};